import { useMutation } from "@tanstack/react-query";
import { baseApi } from "./api";

const AVAILABL_EPACKSGES_ROUTES = {
  AVAILABLE_PACKAGES: "/available-packages",
};

const availablePackagesApi = {
  GET_AVAILABLE_PACKAGES: async (phoneType: "regular" | "tollfree") => {
    const response = await baseApi.get(
      `${AVAILABL_EPACKSGES_ROUTES.AVAILABLE_PACKAGES}/?phone_type=${phoneType}`
    );
    return response;
  },
  GET_AVAILABLE_PACKAGES_BY_ID: async (id: string) => {
    const response = await baseApi.get(
      `${AVAILABL_EPACKSGES_ROUTES.AVAILABLE_PACKAGES}/${id}`
    );
    return response;
  },
  CREATE_AVAILABLE_PACKAGE: async (data: any) => {
    const response = await baseApi.post(
      AVAILABL_EPACKSGES_ROUTES.AVAILABLE_PACKAGES,
      data
    );
    return response;
  },
};

// react query hooks
export function useGetAvailablePackages() {
  return useMutation({
    mutationFn: (phoneType: "regular" | "tollfree") =>
      availablePackagesApi.GET_AVAILABLE_PACKAGES(phoneType),
  });
}

export function useGetAvailablePackagesById() {
  return useMutation({
    mutationFn: (id: string) =>
      availablePackagesApi.GET_AVAILABLE_PACKAGES_BY_ID(id),
  });
}

export function useCreateAvailablePackage() {
  return useMutation({
    mutationFn: (data: any) =>
      availablePackagesApi.CREATE_AVAILABLE_PACKAGE(data),
  });
}
